export default "__VITE_ASSET__MRCY_6G5__"